const App = require('./App.json')
const Guests = require('./Guests.json')
const GuestDetails = require('./GuestDetails.json')
const Crew = require('./Crew.json')
const CrewDetails = require('./CrewDetails.json')
const CrewRolesManagement = require('./CrewRolesManagement.json')
const Dashboard = require('./Dashboard.json')
const Ipm = require('./Ipm.json')
const Visitors = require('./Visitors.json')
const Reports = require('./Reports.json')
const CbpDashboard = require('./CbpDashboard.json')
const ReactTable = require('./ReactTable.json')
const MessageSchedule = require('./MessageSchedule.json')

export default {
  ...App,
  ...Dashboard,
  ...Guests,
  ...Ipm,
  ...Visitors,
  ...Crew,
  ...GuestDetails,
  ...CrewDetails,
  ...CrewRolesManagement,
  ...Reports,
  ...ReactTable,
  ...CbpDashboard,
  ...MessageSchedule
}
